import _ from 'lodash'
import Vue from 'vue'

const httpRequest = function (api, params) {
  return Vue.http
    .get(api, {
      params: params
    })
    .then(function (res) {
      return res.data
    })
}
const request = _.curry(httpRequest)
const httpCheckStatus = request('/api/ftp/statuscheck')
const httpChangeStatus = request('/api/ftp/changestatus')

/**
 *自动安装中可能出现的状态
 */
const STATUS_MAP = {
  0: 'beforeInstall',
  1: 'installing',
  2: 'installed',
  3: 'installEnd',
  4: 'canceling',
  5: 'canceled',
  6: 'cancelEnd',
  7: 'rollbacking',
  8: 'rollbacked',
  9: 'rollbackEnd',
  10: 'error',
  11: 'errorEnd',
  12: 'testing'
}

/**
 * 以下状态会显示弹窗
 */
const SHOW_MASK_STATUS = [
  'installing',
  'installed',
  'beforeCancel',
  'cannotCanel',
  'canceling',
  'canceled',
  'rollbacking',
  'rollbacked',
  'error',
  'overMaxSize',
  'testing',
  'locked'
]

/**
 * 修改状态
 */
const BACKEND_STATUS = [
  'installing',
  'installEnd',
  'canceling',
  'cancelEnd',
  'rollbacking',
  'rollbackEnd',
  'errorEnd'
]
const BACK_STATUS_MAP = {
  installing: '00',
  installEnd: '01',
  canceling: '10',
  cancelEnd: '11',
  rollbacking: '20',
  rollbackEnd: '21',
  errorEnd: '31'
}

/**
 * 以下情况需要向后端轮询
 */
const HEARTBEAT_STATUS = [
  'installing',
  'canceling',
  'cannotCanel',
  'rollbacking'
]

export default {
  data () {
    return {
      pageStatus: '',
      end_time: '',
      showRollback: false,
      showMaskPanel: false,
      errorMessage: ''
    }
  },
  methods: {
    heartbeat (status) {
      let timer = null
      const clearTick = newStatus => {
        if (!timer) return
        clearInterval(timer)
        newStatus && this.updatePage(newStatus)
      }

      return () => {
        timer =
          timer ||
          setInterval(() => {
            httpCheckStatus({
              domainId: this.domain.id
            }).then(({ errno, errmsg, data }) => {
              if (errno === 0) {
                const newStatus = STATUS_MAP[data.status]
                newStatus !== status && clearTick(newStatus)

                if (newStatus === 'error') {
                  this.errorMessage = data.messages
                }
              } else {
                clearTick(null)
                this.$Modal.warn(errmsg)
              }
            })
          }, 3000)
      }
    },

    updatePage (status) {
      this.showMaskPanel = _.indexOf(SHOW_MASK_STATUS, status) > -1
      this.pageStatus = status

      // 当前状态是否需要轮询
      if (_.indexOf(HEARTBEAT_STATUS, status) > -1) {
        this.heartbeat(status)()
      }

      // 如果是 errorEnd 则需要做一些操作
      // .....
      // 显示相应的东西
    },

    checkInstallEnd (status, data) {
      if (status === 'installEnd') {
        this.end_time = data.end_time.slice(0, 10)
        this.showRollback = new Date(data.end_time) > new Date()
      }
    },

    changeStatusTo (status) {
      if (_.indexOf(BACKEND_STATUS, status) < 0) return

      const params = _.clone(this.getFtpParams())
      params.ftpdirs = this.selectedFolders.join(',')
      params.back_status = BACK_STATUS_MAP[status]

      httpChangeStatus(params).then(res => {
        const { errno, errmsg, list } = res

        this.checkInstallEnd(status, list)

        switch (errno) {
          case 0:
            this.updatePage(status)
            break
          case 4:
            this.updatePage('cannotCanel')
            break
          case 6:
            this.updatePage('overMaxSize')
            break
          case 7:
            this.updatePage('locked')
            break
          default:
            this.showMaskPanel = false
            this.$Modal.warn(res.errmsg)
        }
      })
    },

    rollback () {
      this.$Modal.confirm('您真的要恢复网站吗？', res => {
        res && this.changeStatusTo('rollbacking')
      })
    },

    // 进入时检查
    initStatusCheck () {
      httpCheckStatus({
        domainId: this.domain.id
      }).then(({ errno, errmsg, data }) => {
        if (errno === 0) {
          const status = STATUS_MAP[data.status]
          this.checkInstallEnd(status, data)
          this.updatePage(status)
        } else {
          this.$Modal.warn(errmsg)
        }
      })
    }
  },

  computed: {
    modalConfig () {
      return [
        {
          status: 'installing',
          title: '正在安装代码',
          content: '正在安装代码，请耐心等待；安装过程中可以关闭此页面，再次进入页面会提示您安装进度',
          btns: [
            {
              type: 'primary',
              text: '取消安装',
              click: () => {
                this.updatePage('beforeCancel')
              }
            }
          ]
        },
        {
          status: 'beforeCancel',
          title: '确认取消安装吗？',
          content: '取消安装后您网站安装代码失败，无法收集数据',
          btns: [
            {
              type: 'primary',
              text: '确认取消',
              click: () => {
                this.changeStatusTo('canceling')
              }
            },
            {
              type: 'default',
              text: '继续安装',
              click: () => {
                this.updatePage('installing')
              }
            }
          ]
        },
        {
          status: 'canceling',
          title: '正在取消安装',
          content: '请耐心等待，取消安装后，您的网站不会有任何改动',
          btns: []
        },
        {
          status: 'cannotCanel',
          title: '安装即将完成',
          content: '已进入代码安装阶段，该阶段无法进行取消安装操作，请等待安装结果',
          btns: []
        },
        {
          status: 'canceled',
          title: '成功取消',
          content: '代码取消安装成功！您的网站已恢复到初始状态',
          btns: [
            {
              type: 'primary',
              text: '确定',
              click: () => {
                this.changeStatusTo('cancelEnd')
              }
            }
          ]
        },
        {
          status: 'installed',
          title: '安装完成',
          content: '感谢您的耐心等待！',
          btns: [
            {
              type: 'primary',
              text: '确定',
              click: () => {
                this.changeStatusTo('installEnd')
              }
            }
          ]
        },
        {
          status: 'error',
          title: '安装过程中出现异常！',
          content:
            this.errorMessage ||
            '安装异常，请重新安装；若多次安装后仍失败，请将问题反馈至我们的运营人员，我们将尽快为您解决问题',
          btns: [
            {
              type: 'primary',
              text: '确定',
              click: () => {
                this.changeStatusTo('errorEnd')
              }
            }
          ]
        },
        {
          status: 'overMaxSize',
          title: '文件体积过大',
          content:
            '安装异常，选择安装的目录过大，选择与网站代码相关的子目录即可，建议不要直接勾选根目录（勾选根目录会默认选择该目录下的所有子目录)，请重新选择目录后安装',
          btns: [
            {
              type: 'primary',
              text: '确定',
              click: () => {
                this.showMaskPanel = false
              }
            }
          ]
        },
        {
          status: 'locked',
          title: '其他用户正在进行操作',
          content: '请等待他人操作完成，或稍后刷新页面',
          btns: []
        },
        {
          status: 'rollbacking',
          title: '正在恢复中',
          content: '正在恢复您的的网站，请耐心等待；恢复网站后，您的网站不会有任何改动',
          btns: []
        },
        {
          status: 'rollbacked',
          title: '恢复完成',
          content: '您的网站已经恢复到初始状态。',
          btns: [
            {
              type: 'primary',
              text: '确定',
              click: () => {
                this.changeStatusTo('rollbackEnd')
              }
            }
          ]
        },
        {
          status: 'testing',
          title: '原聚合分析站点，不支持重新布码',
          content: '建议新建站点后再重新部署，原聚合分析代码可以保持不变。',
          btns: [
            {
              type: 'primary',
              text: '确定',
              click: () => {
                this.changeStatusTo('rollbackEnd')
              }
            }
          ]
        }
      ]
    }
  },

  created () {
    this.initStatusCheck()
  }
}



// WEBPACK FOOTER //
// ./src/pageview/setting/codeInstall.mixin.js